var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('number',{attrs:{"placeholder":"0","label":_vm.label,"min":0,"controls":"","value":_vm.modelValue,"bottom-bar":_vm.bottomBar},on:{"input":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }